// eslint-disable-next-line
export const END_OF_TOPIC_CONTENT = 'end-of-topic-content';
